import React, { useCallback } from 'react'
import { CriterionClassDisciplineList } from '../types'
import { Link } from 'react-router-dom'
import { CardTitleWrapper } from '../styles';
import { get } from 'lodash';
import moment from 'moment';

type CriterionClassDisciplineCardProps = {
  criterionClassDiscipline: CriterionClassDisciplineList;
  className?: string
}

const CriterionClassDisciplineCard: React.FC<CriterionClassDisciplineCardProps> = ({ criterionClassDiscipline, className }) => {

  const getFormattedDate = useCallback((dateString) => {
    if(!dateString) return 'Não definido'
    return moment(
      dateString
    ).format('DD/MM/YYYY')
  },[])

  return (
    <Link
      to={`/criterios-turma-disciplina/${criterionClassDiscipline.id}/edit`}
      className={`${className} card-100 card-body`}
    >
      <CardTitleWrapper>
      <p className="semi-bold brown text-underline">{criterionClassDiscipline.criterion_name}</p>
      </CardTitleWrapper>
      <div className="form-grid-2 pb-2">
      <span className="mr-4">
        <span className="semi-bold">Turma disciplina:</span>{' '}
        {get(criterionClassDiscipline, 'class_discipline')}
      </span>
      <span className="mr-4">
        <span className="semi-bold">Professor(a):</span>{' '}
        {criterionClassDiscipline.teacher_name}
      </span>
      <span className="mr-4">
        <span className="semi-bold">Valor:</span>{' '}
        {criterionClassDiscipline.criterion_value}
      </span>
      <span className="mr-4">
        <span className="semi-bold">Peso:</span>{' '}
        {criterionClassDiscipline.criterion_weight}
      </span>
      <span className="mr-4">
        <span className="semi-bold">Início da vigência do lançamento: </span>{' '}
        {getFormattedDate(criterionClassDiscipline.release_window_start)}
      </span>
      <span className="mr-4">
        <span className="semi-bold">Fim da vigência do lançamento: </span>{' '}
        {getFormattedDate(criterionClassDiscipline.release_window_end)}
      </span>
    </div>
    </Link>
  )
}
export default CriterionClassDisciplineCard
